import request from '@/api/request'

export const queryNoticeData = params => request('userCenterNoticeDataHttp')//获取默认通知数据
export const changeNoticeData = params => request('userCenterNoticeChangeDataHttp', {params})//更改通知数据
export const queryCardData = params => request('userCenterCardDataHttp', {params, loading:false})//获取我的订阅情报卡片数据
export const queryDataData = params => request('userCenterDataHttp', {params, loading:false})//获取我的订阅数据集合数据
export const changeUserInfo = params => request('userCenterChangeUserInfoHttp', {params,returnAll:true})//更改个人信息
export const serviceApply = params => request('userCenterServiceApply', {params})//服务开通申请
export const serviceApiApply = params => request('userCenterServiceApiApply', {params})//服务开通申请